import React, { Component } from 'react'
import routes from 'routes'
import { hot } from 'react-hot-loader'
import './App.css'

class App extends Component {
  render() {
    return <React.Fragment>{routes()}</React.Fragment>
  }
}

export default hot(module)(App)
